import AlertModal from "library/Molecules/Modal/AlertModal";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

const ExpiredSessionModal = ({ onRefresh, isRefreshing }) => {
  const { t } = useTranslation();

  return (
    <AlertModal
      id="expired-session-modal"
      title={t("newOrder.modals.expiredSessionModal.title")}
      description={t("newOrder.modals.expiredSessionModal.description")}
      onConfirm={onRefresh}
      closeBtnText={t("newOrder.modals.expiredSessionModal.refreshBtn")}
      isDataProcessing={isRefreshing}
      closable={false}
    />
  );
};

ExpiredSessionModal.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  isRefreshing: PropTypes.bool.isRequired,
};

export default ExpiredSessionModal;
